import {
  MUTATION_ADD_DESIGN,
  MUTATION_IS_LOADED,
  MUTATION_SET_EXPORT,
  MUTATION_SET_PRICE,
  MUTATION_SET_PRODUCT_COLORS,
  MUTATION_UPDATE_EXPORT,
  MUTATION_UPDATE_PRODUCT
} from './mutation-types';

export default {
  [MUTATION_UPDATE_PRODUCT]: (state, payload) => {
    state.info = payload;
  },
  [MUTATION_SET_EXPORT]: (state, payload) => {
    state.export = { ...payload };
  },
  [MUTATION_UPDATE_EXPORT]: (state, [printSide, payload]) => {
    state.export.printPlates[printSide].content = payload;
  },
  [MUTATION_IS_LOADED]: (state, payload) => {
    state.isLoaded = payload;
  },
  [MUTATION_SET_PRICE]: (state, price) => {
    state.price = price;
  },
  [MUTATION_ADD_DESIGN]: (state, [printSide, designUrl]) => {
    state.designs[printSide].push(designUrl);
  },
  [MUTATION_SET_PRODUCT_COLORS]: (state, colors) => {
    state.colors = [];
    // eslint-disable-next-line no-unused-vars
    for (let idx in colors) {
      if (Object.prototype.hasOwnProperty.call(colors, idx)) {
        state.colors.push({
          id: parseInt(idx, 10),
          hex: colors[idx].hexValue,
          // this label can be set if no i18n key is provided
          label: colors[idx].title,
          // this is the i18n key
          key: ''
        });
      }
    }
  }
};
